var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"sponsor d-flex justify-content-center",attrs:{"cols":"6","md":"3"}},[_c('a',{staticClass:"d-flex align-items-center justify-content-center",attrs:{"href":_vm.url,"target":"_blank","aria-label":("Visit: " + _vm.name)}},[(_vm.image)?_c('img',{attrs:{"src":_vm.$_addToUrl(_vm.image, _vm.cloudinaryParams),"alt":"","aria-hidden":"true"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5975882a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Sponsor.vue
// module id = GG3N
// module chunks = 1